import DocumentsFileItem from './DocumentsFileItem';

const DocumentsItem = (props) => {
    const {
        files, name, picture, section
    } = props;
    if (files.length === 0) {
        return '';
    }
    const filesHtml = files.map(item => DocumentsFileItem(item)).join('');

    const sectionDescription = section ? `<div class="documents-product__description">${section}</div>` : '';

    return `
        <div class="documents-item">
            <div class="documents-product">
                <div class="documents-product__image" style="background-image: url(${picture})"></div>
                <div class="documents-product__info">
                    <div class="documents-product__title">${name || 'Документ без привязки к продукту'}</div>
                    ${sectionDescription}
                </div>
            </div>
            <div class="documents-certificate">
               ${filesHtml}
            </div>
        </div>
    `;
};

export default DocumentsItem;
